



















































































































import { createComponent } from "../ts/EditFormItem";
export default createComponent();
